import { Ref, ref } from "vue";

export function useAsyncRef<T>(cb: () => Promise<T>, initial: any = null): Ref<T> {
  const theRef = ref(initial);
  cb().then(data => {
    theRef.value = data;
  });
  return theRef;
};
